/* eslint-disable linebreak-style */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-danger */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable quotes */

import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: "https://github.com/rajchhatwani",
    label: "Github",
    icon: faGithub,
  },
  {
    link: "https://www.instagram.com/rajchhatwani39/",
    label: "Instagram",
    icon: faInstagram,
  },
  {
    link: "https://www.linkedin.com/in/rajchhatwani39",
    label: "LinkedIn",
    icon: faLinkedinIn,
  },
  {
    link: "https://x.com/RajChhatwani389",
    label: "Twitter",
    icon: faXTwitter,
  },
  {
    link: "mailto:rajchhatwani39@gmail.com",
    label: "Email",
    icon: faEnvelope,
  },
];

export default data;
